module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sale-team"
  }, [(_vm.showTitle) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('dl', [_c('dt', [_vm._v("负责人")]), _vm._v(" "), _vm._l((_vm.manager), function(item) {
    return _c('dd', {
      key: item.id,
      staticClass: "user-list"
    }, [_c('span', {
      staticClass: "item avatar",
      class: {
        'active': _vm.deleteManagerStatus
      }
    }, [_c('img', {
      attrs: {
        "width": "32",
        "height": "32",
        "src": item.userAvatar,
        "alt": item.userName
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "delete el-icon-circle-close",
      on: {
        "click": function($event) {
          _vm.handleDel(item.id)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), (_vm.moduleName === 'customerApi' && _vm.isCustomerHandover) ? _c('el-button', {
      staticClass: "hand-over",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.handover(item.userId)
        }
      }
    }, [_vm._v("移交")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.moduleName !== 'workOrder' && _vm.isSummit) ? _c('dd', {
    staticClass: "user-list flex"
  }, [_c('span', {
    staticClass: "item option",
    on: {
      "click": function($event) {
        _vm.add('manager')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "item option",
    on: {
      "click": function($event) {
        _vm.deleteManagerStatus = !_vm.deleteManagerStatus
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-minus"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("协同人")]), _vm._v(" "), _c('dd', {
    staticClass: "user-list flex"
  }, [_vm._l((_vm.cooperative), function(item, index) {
    return (index < _vm.cooperCount) ? _c('el-tooltip', {
      key: item.id,
      attrs: {
        "effect": "dark",
        "content": item.userName,
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "item avatar",
      class: {
        'active': _vm.deleteStatus
      }
    }, [_c('img', {
      attrs: {
        "width": "32",
        "height": "32",
        "src": item.userAvatar,
        "alt": item.userName
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "delete el-icon-circle-close",
      on: {
        "click": function($event) {
          _vm.del(item.id)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cooperative.length > 3),
      expression: "cooperative.length > 3"
    }],
    staticClass: "item option more",
    on: {
      "click": _vm.toggleMore
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  })]), _vm._v(" "), _c('span', {
    staticClass: "item option",
    on: {
      "click": function($event) {
        _vm.add('cooperative')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "item option",
    on: {
      "click": _vm.toggleStatus
    }
  }, [_c('i', {
    staticClass: "el-icon-minus"
  })])], 2)])]), _vm._v(" "), (_vm.teamPersonShow) ? _c('team-person', {
    attrs: {
      "transferId": _vm.transferId,
      "selectIds": _vm.id,
      "modal": false,
      "detailModule": _vm.moduleName,
      "module": _vm.operationType,
      "saleTeams": _vm.saleTeams
    },
    on: {
      "refresh": _vm.refreshSaleTeam,
      "closeDialog": _vm.closeDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teamPersonShow),
      expression: "teamPersonShow"
    }],
    staticClass: "v-modal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754a58de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/sale-team.vue
// module id = 1301
// module chunks = 82